import BaseClass from "./BaseClass";

const defaultOptions = {};

export default class User extends BaseClass {

  /**
   * Constructor
   * @param options
   */
    constructor(options)
    {
        super(options, defaultOptions);
        this.clicked = false;

        this.init();
    }

    init()
    {
        String.prototype.pick = function (min, max) {
            var n, chars = '';

            if (typeof max === 'undefined') {
                n = min;
            } else {
                n = min + Math.floor(Math.random() * (max - min + 1));
            }

            for (var i = 0; i < n; i++) {
                chars += this.charAt(Math.floor(Math.random() * this.length));
            }

            return chars;
        };

        $(document).ready(function () {
          // show/hide password on click
            if ($(".password-wrapper").length > 0) {
                $(".auth-form-wrapper .flaticon-svg, .edit-input .flaticon-svg").click(function () {
                    let input = $(this).parent().siblings("input");
                    $(this).parent().css('display', 'none');

                    if (input.attr("type") === "password") {
                        input.attr("type", "text");
                        $(this).parent().siblings('[data-visible]').css('display', 'block');
                    } else {
                        input.attr("type", "password");
                        $(this).parent().siblings('[data-invisible]').css('display', 'block');
                    }
                });
            }

          // generate random password
            $('#password_generate').click(function () {
                let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{10,})");
                let password = User.generatePassword();

              // while password does not match regex keep generating new password
                while (!strongRegex.test(password)) {
                    password = User.generatePassword();
                }

                let input = $(".pass-new");

                input.each(function (i,e) {
                    $(e).parent().find('[data-visible]').show();
                    $(e).parent().find('[data-invisible]').hide();
                    $(e).attr("type", "text");
                    $(e).val(password);
                })
            });

            if ($(".user_side-menu-item").length > 0 && window.innerWidth < window.mobileBreakpoint) {
                $(".user_side-menu-item.active").focus();
            }

          // when profile picture selected in user profile, show its name
            $('#actual-btn').change(function () {
                $(this).prev('label').clone();
                let file = $('#actual-btn')[0].files[0].name;
                $(this).prev('label').text(file);
            });
        });
    }

  /**
   * Function generate random password
   *
   * @returns {string} password
   */
    static generatePassword()
    {
        let length = Math.floor(Math.random() * (15 - 10 + 1)) + 10;
        let charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let password = "";

        for (let i = 0, n = charset.length; i < length; ++i) {
            password += charset.charAt(Math.floor(Math.random() * n));
        }

        return password;
    }

  /**
   * Function that hides edit text and shows cancel and save text/btn
   *
   * @param {Element} e clicked edit text
   */
    editUserInfo(e)
    {
        let neighborDiv = $(e).siblings('.edit-info-save-cancel');
        let hideBlock = $(e).data('hideblock');
        let showBlock = $(e).data('showblock');
        neighborDiv.css('display', 'flex');
        $(e).hide();

        $("[data-showhide='"+hideBlock+"']").hide();
        $("[data-showhide='"+showBlock+"']").show();

        if (showBlock.includes('password')) {
            let allInputsInRow = $(e).parents('tr').find('input');

            allInputsInRow.each(function (i, e) {
                $(e).removeClass('error');
                $(e).parents('.password-wrapper').removeClass('error-wrapper');
            });
        }

    }

  /**
   * Function that shows edit text and hides cancel and save text/btn
   *
   * @param {Element} e clicked cancel text
   */
    cancelEditingUserInfo(e)
    {
        let editDiv = $(e).parent().siblings('.edit-info');
        let hideBlock = $(e).data('hideblock');
        let showBlock = $(e).data('showblock');

        editDiv.css('display', 'flex');

        $("[data-showhide='"+hideBlock+"']").hide();
        $("[data-showhide='"+showBlock+"']").show();

        if (showBlock.includes('password')) {
            let allInputsInRow = $(e).parents('tr').find('input');

            allInputsInRow.each(function (i, e) {
                $(e).removeClass('error');
                $(e).parents('.password-wrapper').removeClass('error-wrapper');
            });
        } else {
            $(e).parent().hide();
        }
    }

  /**
   * Function that shows edit text and hides cancel and save text/btn
   *
   * @param {Element} e clicked cancel text
   */
    saveEditingUserInfo(e)
    {
        let allInputsInRow;

        if ($(e).data('hideblock') == 'show-password') {
            allInputsInRow = $('tr[data-tr-values]').find('input');
        } else {
            allInputsInRow = $(e).parents('tr').find('input');
        }

        let allSelectsInRow = $(e).parents('tr').find('select');
        let url = $(e).data('url');
        let inputsVal = {};
        let selectsVal = {};
        let continueVar = true;
        let timezoneOffsetMinutes = new Date().getTimezoneOffset();
        timezoneOffsetMinutes = timezoneOffsetMinutes == 0 ? 0 : -timezoneOffsetMinutes;

        let browser = window.navigator.appVersion.includes('Chrome') ? 'Chrome' : window.navigator.appVersion.includes('Safari') ? 'Safari' : window.navigator.appVersion.includes('Opera') ? 'Opera' : 'Mozilla';
        let platform = window.navigator.platform;
        let isMobile = false;

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            isMobile = true;
        }

        if (allInputsInRow.length != 0) {
            allInputsInRow.each(function (i, e) {
                if ($(e)[0].name === "email") {
                    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    if (!regex.test($(e).val())) {
                        $(e).css('border-color', 'red');
                        continueVar = false;
                    }
                }

                if ($(e)[0].name === "phone") {
                    inputsVal['dial_code'] = $("#dial_code").val();
                    inputsVal['phone_code'] = $("#phone_code").val();

                    let regex = /^[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{3,6}$/im;
                    if (!regex.test($(e).val())) {
                        $(e).css('border-color', 'red');
                        continueVar = false;
                    } else {
                        $(e).css('border-color', '#C8CBD0');
                    }
                }

                if ($(e)[0].name === "address_postcode") {
                    let regex = /^[0-9\s]*$/;
                    if (!regex.test($(e).val())) {
                        $(e).css('border-color', 'red');
                        continueVar = false;
                    } else {
                        $(e).css('border-color', '#C8CBD0');
                    }
                }

                if (User.isEmptyInput(e)) {
                    inputsVal[$(e)[0].name] = "empty";
                } else {
                    inputsVal[$(e)[0].name] = $(e).val();
                }

            })
        } else {
            inputsVal = null;
        }

        if (allSelectsInRow.length != 0) {
            allSelectsInRow.each(function (i, e) {
                selectsVal[$(e)[0].name] = $(e).val();
            })
        } else {
            selectsVal = null;
        }

        let locale = $('meta[name="country"]').attr('content');

        if (continueVar) {
            $.ajax({
                headers: {
                    'X-App-Locale': locale,
                },
                url: url,
                method: 'post',
                data: {
                    selectsVal: selectsVal,
                    inputsVal: inputsVal,
                    timezoneOffsetMinutes: timezoneOffsetMinutes,
                    browser: browser,
                    isMobile: isMobile,
                    platform: platform,
                    captcha: $('#recaptcha-token').val()
                },
                success: function (data) {
                    recaptcha((token) => {
                        $('#recaptcha-token').val(token);
                    });

                    let parsedData = JSON.parse(data);
                    let showBlock = $(e).data('showblock');
                    $('.alert.alert-success').remove();

                    if (showBlock.includes("password") && !parsedData['passwordOldFail'] && !parsedData['passwordRetypeFail'] && !parsedData['passwordQualityFail']) {
                        $("[data-showerror='show-password-retype-error']").parents('.password-wrapper').removeClass('error-wrapper');
                        $("[data-showerror='show-password-new-error']").parents('.password-wrapper').removeClass('error-wrapper');
                        $("[data-showerror='show-password-old-error']").parents('.password-wrapper').removeClass('error-wrapper');

                        $(allInputsInRow).removeClass('error');

                        $(".user-table-wrapper").first().before(parsedData['msg']);
                        $('[data-cancelButton]').click();
                    } else {
                        if (!User.isSaveFail(parsedData)) {
                            cancelEditingUserInfo(e);
                            if (showBlock.includes('username')) {
                                  $("[data-showhideusername]").html(parsedData['value'][0]);
                            } else {
                                $("[data-showhide='"+showBlock+"']").each(function (i, e) {
                                    if (parsedData['value'] !== null && parsedData['value'][i] !== null) {
                                        $(e).html(parsedData['value'][i]);
                                    }
                                });
                            }


                            if (showBlock.includes("username") || showBlock.includes("password") || showBlock.includes("email")) {
                                $(allInputsInRow).removeClass('error');
                                $("[data-showerror='show-username-error']").css('display', 'none');
                                $("[data-showerror='show-email-error']").css('display', 'none');

                                if (showBlock.includes("username")) {
                                    $("[data-showerror='show-username-ok']").css('display', 'block');
                                } else if (showBlock.includes("email")) {
                                    if (!parsedData['emailSame']) {
                                        $("[data-btnverified]").addClass('btn-not-verified');
                                        $('[data-btnverified]').text($('input[name="not_verified"]').val());
                                    } else {
                                        $("[data-btnverified]").removeClass('btn-not-verified');
                                        $('[data-btnverified]').text($('input[name="verified"]').val());
                                    }

                                    $("[data-showerror='show-email-ok']").css('display', 'block');
                                }
                            }
                            $(".user-table-wrapper").first().before(parsedData['msg']);
                        } else {
                            if (!showBlock.includes("password") && !showBlock.includes("name")) {
                                $(allInputsInRow).addClass('error');
                            }

                            if (showBlock.includes("username")) {
                                $(allInputsInRow).addClass('error');
                                $("[data-showerror='show-username-error']").css('display', 'block');
                                $("[data-showerror='show-username-ok']").css('display', 'none');
                            } else if (showBlock.includes("email")) {
                                $("[data-showerror='show-email-error']").css('display', 'block');
                                $("[data-showerror='show-email-ok']").css('display', 'none');
                            }

                            let oldPassError = $("[data-showerror='show-password-old-error']");
                            let retypePassError = $("[data-showerror='show-password-retype-error']")
                            let newPassError = $("[data-showerror='show-password-new-error']");

                            if (parsedData['passwordOldFail']) {
                                $(oldPassError).siblings('input').addClass('error');
                                $(oldPassError).parent('.password-wrapper').addClass('error-wrapper');
                            } else {
                                $(oldPassError).parent('.password-wrapper').removeClass('error-wrapper');
                                $(oldPassError).siblings('input').removeClass('error');
                            }

                            if (parsedData['passwordRetypeFail']) {
                                $(retypePassError).siblings('input').addClass('error');
                                $(retypePassError).parent('.password-wrapper').addClass('error-wrapper');
                            } else {
                                $(retypePassError).parent('.password-wrapper').removeClass('error-wrapper');
                                $(retypePassError).siblings('input').removeClass('error');
                            }

                            if (parsedData['passwordQualityFail']) {
                                $(newPassError).siblings('input').addClass('error');
                                $(newPassError).parent('.password-wrapper').addClass('error-wrapper');
                            } else {
                                $(newPassError).parent('.password-wrapper').removeClass('error-wrapper');
                                $(newPassError).siblings('input').removeClass('error');
                            }

                            if (parsedData['nameFail']) {
                                $("input[name='name_input']").addClass('error');
                                $("[data-showerror='show-name-error']").css('display', 'block');
                            } else {
                                $("input[name='name_input']").removeClass('error');
                                $("[data-showerror='show-name-error']").css('display', 'none');
                            }

                            if (parsedData['lastNameFail']) {
                                $("input[name='last_name_input']").addClass('error');
                                $("[data-showerror='show-last-name-error']").css('display', 'block');
                            } else {
                                $("input[name='last_name_input']").removeClass('error');
                                $("[data-showerror='show-last-name-error']").css('display', 'none');
                            }
                        }
                    }

                      // allow alert dissmiss
                      $('.alert').alert();
                }
            });
        }
    }

  /**
   * Function that shows img in modal after showing the modal itself
   */
    showCloseModalImg(modal, e)
    {
        $(modal+" .close-modal").show();

        // if it is modal for deleting user review put ID of review to hidden input
        if (modal == "#deleteModal") {
            $("input[name='delete_review']").val($(e).data('review'));
        }

        if (modal == "#cancelModal") {
            $("input[name='cancel_booking']").val($(e).data('booking'));
        }
    }

  /**
   * Function that cancel reservation
   */
    cancelReservation()
    {
        let bookingID = $('[data-cancelbooking]').val();
        let locale = $('meta[name="country"]').attr('content');
        let that = this;

        // should not happen
        if (bookingID !== "" && !that.clicked) {
            that.clicked = true;
            $.ajax({
                headers: {
                    'X-App-Locale': locale,
                },
                url: window.location.origin + '/user/cancel-reservation',
                method: 'post',
                data: {
                    bookingID: bookingID
                },
                success: function (data) {
                    $('#cancel_modal').modal('hide');
                    window.location.href = window.location.origin + '/reservation-id/' + bookingID;
                },
                error: function (error) {
                    that.clicked = false;
                }
            })
        }
    }

  /**
   * This function returns if input is empty
   * It is checked only in inputs which MUST NOT BE EMPTY
   *
   * @param {Element} e input
   * @returns {boolean}
   */
    static isEmptyInput(e)
    {
        return (($(e).val() === "" || !$(e).val().replace(/\s/g, '').length) && ($(e)[0].name === "phone" || $(e)[0].name === "username" || $(e)[0].name.includes("address") || $(e)[0].name.includes("password") || $(e)[0].name === "name_input" || $(e)[0].name === "last_name_input"));
    }

  /**
   * This function returns if error occurred while saving
   *
   * @param {Json} parsedData data
   * @returns {boolean}
   */
    static isSaveFail(parsedData)
    {
        return parsedData['usernameFail'] || parsedData['passwordOldFail'] || parsedData['passwordRetypeFail'] || parsedData['passwordQualityFail'] || parsedData['emailFail'] || parsedData['nameFail'] || parsedData['lastNameFail'];
    }

    /**
     * Function that resends verification email
     */
    sendVerificationEmail(element)
    {
        let locale = $('meta[name="country"]').attr('content');

        $.ajax({
            headers: {
                'X-App-Locale': locale,
            },
            data: {
                userId: $(element).data('user')
            },
            url: window.location.origin + '/user/resend-verification-email',
            method: 'post',
            success: function(data) {
                let parsedData = JSON.parse(data);

                $("#email_verification").first().before(parsedData['msg']);
                // allow alert dissmiss
                $('.alert').alert();
            },
        })
    }
}
